// extracted by mini-css-extract-plugin
module.exports = {"container":"Flex_container__2QLyF","row":"Flex_row__OeKZp","column":"Flex_column__cxzdS"};